import { create } from 'zustand';

const useRequiredActionsStore = create(
    (set,) => ({
        requiredActionsLoaded: false,
        setRequiredActionsLoaded: (value) => {
            set({
                requiredActionsLoaded: value,
            });
        },

        canIgnore: true,
        setCanIgnore: (value) => {
            set({
                canIgnore: value,
            });
        },

        requiredActionsShown: false,
        setRequiredActionsShown: (value) => {
            set({
                requiredActionsShown: value,
            });
        },

        modalOpen: false,
        setModalOpen: (value) => {
            set({
                modalOpen: value,
            });
        },

        requiredActions: [],
        setRequiredActions: (value) => {
            set({
                requiredActions: value,
            });
        },

        reloadCounter: 0,
        reloadShowNext: false,
        reload: ({ showNext = false } = {}) => {
            set(state => ({
                reloadCounter: state.reloadCounter + 1,
                reloadShowNext: showNext,
            }));
        },
        clearReloadShowNext: () => {
            set({
                reloadShowNext: false,
            });
        },
    }),
);

export default useRequiredActionsStore;